/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, DeviceCatalogueDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceCatalogueDtoFromJSON,
    DeviceCatalogueDtoToJSON,
} from "../models/index";

export interface DeviceCatalogueDeleteRequest {
    deviceCatalogueId: number;
}

export interface DeviceCatalogueInsertUpdateRequest {
    body?: DeviceCatalogueDto;
}

export interface DeviceCatalogueLinkRequest {
    deviceIdentity: string;
    deviceCatalogueId?: number;
}

/**
 *
 */
export class DeviceCatalogueHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Delete a device catalogue entry.
     */
    async deviceCatalogueDeleteRaw(
        requestParameters: DeviceCatalogueDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceCatalogueId"] == null) {
            throw new runtime.RequiredError(
                "deviceCatalogueId",
                'Required parameter "deviceCatalogueId" was null or undefined when calling deviceCatalogueDelete().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-catalogue/{deviceCatalogueId}`.replace(
                    `{${"deviceCatalogueId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceCatalogueId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete a device catalogue entry.
     */
    async deviceCatalogueDelete(
        requestParameters: DeviceCatalogueDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceCatalogueDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create or update a device catalogue entry. Pass DeviceCatalogueId = 0 to create a new entry.
     */
    async deviceCatalogueInsertUpdateRaw(
        requestParameters: DeviceCatalogueInsertUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-catalogue`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceCatalogueDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create or update a device catalogue entry. Pass DeviceCatalogueId = 0 to create a new entry.
     */
    async deviceCatalogueInsertUpdate(
        requestParameters: DeviceCatalogueInsertUpdateRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceCatalogueInsertUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Link or unlink a device to a catalogue entry
     */
    async deviceCatalogueLinkRaw(
        requestParameters: DeviceCatalogueLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceCatalogueLink().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceCatalogueId"] != null) {
            queryParameters["deviceCatalogueId"] =
                requestParameters["deviceCatalogueId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/device-catalogue`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Link or unlink a device to a catalogue entry
     */
    async deviceCatalogueLink(
        requestParameters: DeviceCatalogueLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceCatalogueLinkRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData endpoint listing all device catalogue entries.
     */
    async deviceCatalogueODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceCatalogueDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-catalogue-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceCatalogueDtoFromJSON),
        );
    }

    /**
     * OData endpoint listing all device catalogue entries.
     */
    async deviceCatalogueOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceCatalogueDto>> {
        const response = await this.deviceCatalogueODataRaw(initOverrides);
        return await response.value();
    }
}
